const all = ['professions']
const list = () => [...all, 'list']

export const professionsKeys = {
  all,
  list,
}
